import _ from 'lodash';
import { useIntl } from "react-intl";
import { NavLink } from "react-router-dom";
import { useEffect, useState } from "react";

//Components
import DataView from 'Components/DataView';

//Helpers
import { getDateFormatted } from 'Core/data/Helpers';

//Styles
import "./index.scss";

const DetailTable = (props) => {
    const { result, onChangeColumns } = props
    const { messages } = useIntl();

    //Local States
    const [externalData, setExternalData] = useState([]);
    const [columns, setColumns] = useState([]);

    useEffect(() => {
        if (result) {
            let list = JSON.parse(result)
            setExternalData(list)
            let columns = _.keys(list[0]);
            columns = columns.map((column) => ({
                key: column,
                title: messages[`vidfleetClips_${column}`] || column,
                width: column === "id" ? 50 : 200,
                show: true,
                functionString: 'return row?.id',
                code: `vidfleetClips_${column}` || column,
                render: (item) => {
                    let date = ["createdOnDb", "startDate", "endDate"]
                    let units = ["esn", "unitId"]
                    let value = <span>{item[column]}</span>

                    if (date.includes(column)) value = <span>{getDateFormatted(item[column], "date", "datetime", null)}</span>

                    if (units.includes(column)) {
                        value = (
                            <NavLink to={`/app/devices/overview/${item[column]}`} style={{ color: 'black' }}>
                                <span style={{ textDecoration: 'underline', cursor: 'pointer' }}>{item[column]}</span>
                            </NavLink>
                        )
                    }
                    return value
                }
            }))
            onChangeColumns && onChangeColumns(columns)
            setColumns(columns)
        }

        return () => {
            setExternalData([])
            setColumns([])
        }
    }, [result])

    return (
        <div className="dashboard-detail-table">
            <DataView
                noFilters
                noSearch
                noSplit
                externalData={externalData || []}
                columns={columns}
                externalLoading={false}
                height="76vh"
                disableItemSelection
                onChangeColumns={(items) => setColumns(items)}
                hidePagination
                noPDF
                isPXSource
                noRefresh
                noDensity
            />
        </div>
    )
}

export default DetailTable